import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { useUnpublishCampaign } from './useUnpublishCampaign'

export type UnpublishCampaignModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  givingCampaign: {
    id: string
    title: string
  } | null
  onSuccess: () => void
  onError: (error?: Record<'code' | 'message' | 'title', string>) => void
}>

export function UnpublishCampaignModal({
  isOpen,
  handleClose,
  givingCampaign,
  onSuccess,
  onError
}: UnpublishCampaignModalProps) {
  const { t } = useTranslation()

  const { isLoading, unpublishCampaign } = useUnpublishCampaign({
    campaignId: givingCampaign?.id,
    onUnpublished: onSuccess,
    onError
  })

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ActionModal
        title={t('typography.givingCampaigns.unpublishCampaign.title')}
        primaryButtonText={t('typography.givingCampaigns.unpublishCampaign.button')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={unpublishCampaign}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.givingCampaigns.unpublishCampaign.description"
          components={{ b: <b /> }}
          values={{ campaignName: givingCampaign?.title ?? '' }}
        />
      </ActionModal>
    </Modal>
  )
}
